/**
 * El mínimo del motivo de consulta (D-04), para las dos pantallas que enseñan
 * la cuenta atrás de caracteres antes de mandar el formulario.
 *
 * Es un **espejo**, no la fuente de verdad: la autoridad vive en
 * `apps/api/src/esquemas.ts`, que es quien de verdad rechaza un motivo corto.
 * Mismo criterio que D-65 aplicó a los nombres de cookie — no se importa desde
 * la API a propósito, porque esto es una mejora de experiencia, no una
 * garantía; si algún día este número y el del servidor se desincronizan, el
 * peor caso es un contador que no cuadra por un instante, no un dato inválido
 * que llegue a guardarse (D-66).
 */
export const MINIMO_DEL_MOTIVO = 20;

/** ¿El motivo ya llega al mínimo, contando sin los espacios de los extremos? */
export function motivoSuficiente(texto: string): boolean {
  return texto.trim().length >= MINIMO_DEL_MOTIVO;
}

/** Cuántos caracteres faltan todavía, para el contador en pantalla. Nunca negativo. */
export function caracteresQueFaltan(texto: string): number {
  return Math.max(0, MINIMO_DEL_MOTIVO - texto.trim().length);
}
